// source: async_job.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

goog.exportSymbol('proto.filesync_daemon.AsyncJob', null, global);
goog.exportSymbol('proto.filesync_daemon.AsyncJob.Status', null, global);
goog.exportSymbol('proto.filesync_daemon.AsyncJob.Type', null, global);
goog.exportSymbol('proto.filesync_daemon.CloudEvent', null, global);
goog.exportSymbol('proto.filesync_daemon.CloudEvent.Status', null, global);
goog.exportSymbol('proto.filesync_daemon.CloudLockEvent', null, global);
goog.exportSymbol('proto.filesync_daemon.EventType', null, global);
goog.exportSymbol('proto.filesync_daemon.Notification', null, global);
goog.exportSymbol('proto.filesync_daemon.Notification.ReconnectDataCase', null, global);
goog.exportSymbol('proto.filesync_daemon.Notification.Type', null, global);
goog.exportSymbol('proto.filesync_daemon.OpenPathEvent', null, global);
goog.exportSymbol('proto.filesync_daemon.PathNodeInfo', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.filesync_daemon.Notification = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.filesync_daemon.Notification.repeatedFields_, proto.filesync_daemon.Notification.oneofGroups_);
};
goog.inherits(proto.filesync_daemon.Notification, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.filesync_daemon.Notification.displayName = 'proto.filesync_daemon.Notification';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.filesync_daemon.OpenPathEvent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.filesync_daemon.OpenPathEvent.repeatedFields_, null);
};
goog.inherits(proto.filesync_daemon.OpenPathEvent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.filesync_daemon.OpenPathEvent.displayName = 'proto.filesync_daemon.OpenPathEvent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.filesync_daemon.CloudLockEvent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.filesync_daemon.CloudLockEvent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.filesync_daemon.CloudLockEvent.displayName = 'proto.filesync_daemon.CloudLockEvent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.filesync_daemon.PathNodeInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.filesync_daemon.PathNodeInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.filesync_daemon.PathNodeInfo.displayName = 'proto.filesync_daemon.PathNodeInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.filesync_daemon.CloudEvent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.filesync_daemon.CloudEvent.repeatedFields_, null);
};
goog.inherits(proto.filesync_daemon.CloudEvent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.filesync_daemon.CloudEvent.displayName = 'proto.filesync_daemon.CloudEvent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.filesync_daemon.AsyncJob = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.filesync_daemon.AsyncJob, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.filesync_daemon.AsyncJob.displayName = 'proto.filesync_daemon.AsyncJob';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.filesync_daemon.Notification.repeatedFields_ = [2,3,4,5];

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.filesync_daemon.Notification.oneofGroups_ = [[6]];

/**
 * @enum {number}
 */
proto.filesync_daemon.Notification.ReconnectDataCase = {
  RECONNECT_DATA_NOT_SET: 0,
  USER_ID: 6
};

/**
 * @return {proto.filesync_daemon.Notification.ReconnectDataCase}
 */
proto.filesync_daemon.Notification.prototype.getReconnectDataCase = function() {
  return /** @type {proto.filesync_daemon.Notification.ReconnectDataCase} */(jspb.Message.computeOneofCase(this, proto.filesync_daemon.Notification.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.filesync_daemon.Notification.prototype.toObject = function(opt_includeInstance) {
  return proto.filesync_daemon.Notification.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.filesync_daemon.Notification} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.filesync_daemon.Notification.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    asyncJobsList: jspb.Message.toObjectList(msg.getAsyncJobsList(),
    proto.filesync_daemon.AsyncJob.toObject, includeInstance),
    cloudEventsList: jspb.Message.toObjectList(msg.getCloudEventsList(),
    proto.filesync_daemon.CloudEvent.toObject, includeInstance),
    openPathEventsList: jspb.Message.toObjectList(msg.getOpenPathEventsList(),
    proto.filesync_daemon.OpenPathEvent.toObject, includeInstance),
    cloudLockEventsList: jspb.Message.toObjectList(msg.getCloudLockEventsList(),
    proto.filesync_daemon.CloudLockEvent.toObject, includeInstance),
    userId: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.filesync_daemon.Notification}
 */
proto.filesync_daemon.Notification.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.filesync_daemon.Notification;
  return proto.filesync_daemon.Notification.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.filesync_daemon.Notification} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.filesync_daemon.Notification}
 */
proto.filesync_daemon.Notification.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.filesync_daemon.Notification.Type} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = new proto.filesync_daemon.AsyncJob;
      reader.readMessage(value,proto.filesync_daemon.AsyncJob.deserializeBinaryFromReader);
      msg.addAsyncJobs(value);
      break;
    case 3:
      var value = new proto.filesync_daemon.CloudEvent;
      reader.readMessage(value,proto.filesync_daemon.CloudEvent.deserializeBinaryFromReader);
      msg.addCloudEvents(value);
      break;
    case 4:
      var value = new proto.filesync_daemon.OpenPathEvent;
      reader.readMessage(value,proto.filesync_daemon.OpenPathEvent.deserializeBinaryFromReader);
      msg.addOpenPathEvents(value);
      break;
    case 5:
      var value = new proto.filesync_daemon.CloudLockEvent;
      reader.readMessage(value,proto.filesync_daemon.CloudLockEvent.deserializeBinaryFromReader);
      msg.addCloudLockEvents(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.filesync_daemon.Notification.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.filesync_daemon.Notification.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.filesync_daemon.Notification} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.filesync_daemon.Notification.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {!proto.filesync_daemon.Notification.Type} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getAsyncJobsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.filesync_daemon.AsyncJob.serializeBinaryToWriter
    );
  }
  f = message.getCloudEventsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.filesync_daemon.CloudEvent.serializeBinaryToWriter
    );
  }
  f = message.getOpenPathEventsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.filesync_daemon.OpenPathEvent.serializeBinaryToWriter
    );
  }
  f = message.getCloudLockEventsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.filesync_daemon.CloudLockEvent.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.filesync_daemon.Notification.Type = {
  UNKNOWN: 0,
  ASYNCJOB: 1,
  CLOUDEVENT: 2,
  RECONNECT: 3,
  OPENPATH: 4,
  CLOUDLOCK: 5
};

/**
 * required Type type = 1;
 * @return {!proto.filesync_daemon.Notification.Type}
 */
proto.filesync_daemon.Notification.prototype.getType = function() {
  return /** @type {!proto.filesync_daemon.Notification.Type} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.filesync_daemon.Notification.Type} value
 * @return {!proto.filesync_daemon.Notification} returns this
 */
proto.filesync_daemon.Notification.prototype.setType = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.Notification} returns this
 */
proto.filesync_daemon.Notification.prototype.clearType = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.Notification.prototype.hasType = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated AsyncJob async_jobs = 2;
 * @return {!Array<!proto.filesync_daemon.AsyncJob>}
 */
proto.filesync_daemon.Notification.prototype.getAsyncJobsList = function() {
  return /** @type{!Array<!proto.filesync_daemon.AsyncJob>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.filesync_daemon.AsyncJob, 2));
};


/**
 * @param {!Array<!proto.filesync_daemon.AsyncJob>} value
 * @return {!proto.filesync_daemon.Notification} returns this
*/
proto.filesync_daemon.Notification.prototype.setAsyncJobsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.filesync_daemon.AsyncJob=} opt_value
 * @param {number=} opt_index
 * @return {!proto.filesync_daemon.AsyncJob}
 */
proto.filesync_daemon.Notification.prototype.addAsyncJobs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.filesync_daemon.AsyncJob, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.filesync_daemon.Notification} returns this
 */
proto.filesync_daemon.Notification.prototype.clearAsyncJobsList = function() {
  return this.setAsyncJobsList([]);
};


/**
 * repeated CloudEvent cloud_events = 3;
 * @return {!Array<!proto.filesync_daemon.CloudEvent>}
 */
proto.filesync_daemon.Notification.prototype.getCloudEventsList = function() {
  return /** @type{!Array<!proto.filesync_daemon.CloudEvent>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.filesync_daemon.CloudEvent, 3));
};


/**
 * @param {!Array<!proto.filesync_daemon.CloudEvent>} value
 * @return {!proto.filesync_daemon.Notification} returns this
*/
proto.filesync_daemon.Notification.prototype.setCloudEventsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.filesync_daemon.CloudEvent=} opt_value
 * @param {number=} opt_index
 * @return {!proto.filesync_daemon.CloudEvent}
 */
proto.filesync_daemon.Notification.prototype.addCloudEvents = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.filesync_daemon.CloudEvent, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.filesync_daemon.Notification} returns this
 */
proto.filesync_daemon.Notification.prototype.clearCloudEventsList = function() {
  return this.setCloudEventsList([]);
};


/**
 * repeated OpenPathEvent open_path_events = 4;
 * @return {!Array<!proto.filesync_daemon.OpenPathEvent>}
 */
proto.filesync_daemon.Notification.prototype.getOpenPathEventsList = function() {
  return /** @type{!Array<!proto.filesync_daemon.OpenPathEvent>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.filesync_daemon.OpenPathEvent, 4));
};


/**
 * @param {!Array<!proto.filesync_daemon.OpenPathEvent>} value
 * @return {!proto.filesync_daemon.Notification} returns this
*/
proto.filesync_daemon.Notification.prototype.setOpenPathEventsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.filesync_daemon.OpenPathEvent=} opt_value
 * @param {number=} opt_index
 * @return {!proto.filesync_daemon.OpenPathEvent}
 */
proto.filesync_daemon.Notification.prototype.addOpenPathEvents = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.filesync_daemon.OpenPathEvent, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.filesync_daemon.Notification} returns this
 */
proto.filesync_daemon.Notification.prototype.clearOpenPathEventsList = function() {
  return this.setOpenPathEventsList([]);
};


/**
 * repeated CloudLockEvent cloud_lock_events = 5;
 * @return {!Array<!proto.filesync_daemon.CloudLockEvent>}
 */
proto.filesync_daemon.Notification.prototype.getCloudLockEventsList = function() {
  return /** @type{!Array<!proto.filesync_daemon.CloudLockEvent>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.filesync_daemon.CloudLockEvent, 5));
};


/**
 * @param {!Array<!proto.filesync_daemon.CloudLockEvent>} value
 * @return {!proto.filesync_daemon.Notification} returns this
*/
proto.filesync_daemon.Notification.prototype.setCloudLockEventsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.filesync_daemon.CloudLockEvent=} opt_value
 * @param {number=} opt_index
 * @return {!proto.filesync_daemon.CloudLockEvent}
 */
proto.filesync_daemon.Notification.prototype.addCloudLockEvents = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.filesync_daemon.CloudLockEvent, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.filesync_daemon.Notification} returns this
 */
proto.filesync_daemon.Notification.prototype.clearCloudLockEventsList = function() {
  return this.setCloudLockEventsList([]);
};


/**
 * optional string user_id = 6;
 * @return {string}
 */
proto.filesync_daemon.Notification.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.filesync_daemon.Notification} returns this
 */
proto.filesync_daemon.Notification.prototype.setUserId = function(value) {
  return jspb.Message.setOneofField(this, 6, proto.filesync_daemon.Notification.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.Notification} returns this
 */
proto.filesync_daemon.Notification.prototype.clearUserId = function() {
  return jspb.Message.setOneofField(this, 6, proto.filesync_daemon.Notification.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.Notification.prototype.hasUserId = function() {
  return jspb.Message.getField(this, 6) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.filesync_daemon.OpenPathEvent.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.filesync_daemon.OpenPathEvent.prototype.toObject = function(opt_includeInstance) {
  return proto.filesync_daemon.OpenPathEvent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.filesync_daemon.OpenPathEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.filesync_daemon.OpenPathEvent.toObject = function(includeInstance, msg) {
  var f, obj = {
    pathNodesInfoList: jspb.Message.toObjectList(msg.getPathNodesInfoList(),
    proto.filesync_daemon.PathNodeInfo.toObject, includeInstance),
    userid: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.filesync_daemon.OpenPathEvent}
 */
proto.filesync_daemon.OpenPathEvent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.filesync_daemon.OpenPathEvent;
  return proto.filesync_daemon.OpenPathEvent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.filesync_daemon.OpenPathEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.filesync_daemon.OpenPathEvent}
 */
proto.filesync_daemon.OpenPathEvent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.filesync_daemon.PathNodeInfo;
      reader.readMessage(value,proto.filesync_daemon.PathNodeInfo.deserializeBinaryFromReader);
      msg.addPathNodesInfo(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.filesync_daemon.OpenPathEvent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.filesync_daemon.OpenPathEvent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.filesync_daemon.OpenPathEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.filesync_daemon.OpenPathEvent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPathNodesInfoList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.filesync_daemon.PathNodeInfo.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated PathNodeInfo path_nodes_info = 1;
 * @return {!Array<!proto.filesync_daemon.PathNodeInfo>}
 */
proto.filesync_daemon.OpenPathEvent.prototype.getPathNodesInfoList = function() {
  return /** @type{!Array<!proto.filesync_daemon.PathNodeInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.filesync_daemon.PathNodeInfo, 1));
};


/**
 * @param {!Array<!proto.filesync_daemon.PathNodeInfo>} value
 * @return {!proto.filesync_daemon.OpenPathEvent} returns this
*/
proto.filesync_daemon.OpenPathEvent.prototype.setPathNodesInfoList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.filesync_daemon.PathNodeInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.filesync_daemon.PathNodeInfo}
 */
proto.filesync_daemon.OpenPathEvent.prototype.addPathNodesInfo = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.filesync_daemon.PathNodeInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.filesync_daemon.OpenPathEvent} returns this
 */
proto.filesync_daemon.OpenPathEvent.prototype.clearPathNodesInfoList = function() {
  return this.setPathNodesInfoList([]);
};


/**
 * required string userID = 2;
 * @return {string}
 */
proto.filesync_daemon.OpenPathEvent.prototype.getUserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.filesync_daemon.OpenPathEvent} returns this
 */
proto.filesync_daemon.OpenPathEvent.prototype.setUserid = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.OpenPathEvent} returns this
 */
proto.filesync_daemon.OpenPathEvent.prototype.clearUserid = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.OpenPathEvent.prototype.hasUserid = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.filesync_daemon.CloudLockEvent.prototype.toObject = function(opt_includeInstance) {
  return proto.filesync_daemon.CloudLockEvent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.filesync_daemon.CloudLockEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.filesync_daemon.CloudLockEvent.toObject = function(includeInstance, msg) {
  var f, obj = {
    userid: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    iscloudlocked: (f = jspb.Message.getBooleanField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.filesync_daemon.CloudLockEvent}
 */
proto.filesync_daemon.CloudLockEvent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.filesync_daemon.CloudLockEvent;
  return proto.filesync_daemon.CloudLockEvent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.filesync_daemon.CloudLockEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.filesync_daemon.CloudLockEvent}
 */
proto.filesync_daemon.CloudLockEvent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserid(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIscloudlocked(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.filesync_daemon.CloudLockEvent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.filesync_daemon.CloudLockEvent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.filesync_daemon.CloudLockEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.filesync_daemon.CloudLockEvent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * required string userID = 1;
 * @return {string}
 */
proto.filesync_daemon.CloudLockEvent.prototype.getUserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.filesync_daemon.CloudLockEvent} returns this
 */
proto.filesync_daemon.CloudLockEvent.prototype.setUserid = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.CloudLockEvent} returns this
 */
proto.filesync_daemon.CloudLockEvent.prototype.clearUserid = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.CloudLockEvent.prototype.hasUserid = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * required bool isCloudLocked = 2;
 * @return {boolean}
 */
proto.filesync_daemon.CloudLockEvent.prototype.getIscloudlocked = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.filesync_daemon.CloudLockEvent} returns this
 */
proto.filesync_daemon.CloudLockEvent.prototype.setIscloudlocked = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.CloudLockEvent} returns this
 */
proto.filesync_daemon.CloudLockEvent.prototype.clearIscloudlocked = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.CloudLockEvent.prototype.hasIscloudlocked = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.filesync_daemon.PathNodeInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.filesync_daemon.PathNodeInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.filesync_daemon.PathNodeInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.filesync_daemon.PathNodeInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    colluuid: msg.getColluuid_asB64(),
    maintaineruuid: msg.getMaintaineruuid_asB64(),
    parentuuid: msg.getParentuuid_asB64(),
    entryuuid: msg.getEntryuuid_asB64(),
    fstype: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
    version: msg.getVersion_asB64(),
    lastlocalfsupdate: (f = jspb.Message.getField(msg, 7)) == null ? undefined : f,
    linkedcolluuid: msg.getLinkedcolluuid_asB64(),
    linkedcollrootuuid: msg.getLinkedcollrootuuid_asB64(),
    name: (f = jspb.Message.getField(msg, 10)) == null ? undefined : f,
    filesize: (f = jspb.Message.getField(msg, 11)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.filesync_daemon.PathNodeInfo}
 */
proto.filesync_daemon.PathNodeInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.filesync_daemon.PathNodeInfo;
  return proto.filesync_daemon.PathNodeInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.filesync_daemon.PathNodeInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.filesync_daemon.PathNodeInfo}
 */
proto.filesync_daemon.PathNodeInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setColluuid(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setMaintaineruuid(value);
      break;
    case 3:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setParentuuid(value);
      break;
    case 4:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setEntryuuid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setFstype(value);
      break;
    case 6:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setVersion(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastlocalfsupdate(value);
      break;
    case 8:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setLinkedcolluuid(value);
      break;
    case 9:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setLinkedcollrootuuid(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setFilesize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.filesync_daemon.PathNodeInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.filesync_daemon.PathNodeInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.filesync_daemon.PathNodeInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.filesync_daemon.PathNodeInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeBytes(
      2,
      f
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeBytes(
      3,
      f
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeBytes(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeBytes(
      6,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeString(
      7,
      f
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeBytes(
      8,
      f
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeBytes(
      9,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeString(
      10,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeUint64(
      11,
      f
    );
  }
};


/**
 * required bytes collUUID = 1;
 * @return {!(string|Uint8Array)}
 */
proto.filesync_daemon.PathNodeInfo.prototype.getColluuid = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * required bytes collUUID = 1;
 * This is a type-conversion wrapper around `getColluuid()`
 * @return {string}
 */
proto.filesync_daemon.PathNodeInfo.prototype.getColluuid_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getColluuid()));
};


/**
 * required bytes collUUID = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getColluuid()`
 * @return {!Uint8Array}
 */
proto.filesync_daemon.PathNodeInfo.prototype.getColluuid_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getColluuid()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.filesync_daemon.PathNodeInfo} returns this
 */
proto.filesync_daemon.PathNodeInfo.prototype.setColluuid = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.PathNodeInfo} returns this
 */
proto.filesync_daemon.PathNodeInfo.prototype.clearColluuid = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.PathNodeInfo.prototype.hasColluuid = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * required bytes maintainerUUID = 2;
 * @return {!(string|Uint8Array)}
 */
proto.filesync_daemon.PathNodeInfo.prototype.getMaintaineruuid = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * required bytes maintainerUUID = 2;
 * This is a type-conversion wrapper around `getMaintaineruuid()`
 * @return {string}
 */
proto.filesync_daemon.PathNodeInfo.prototype.getMaintaineruuid_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getMaintaineruuid()));
};


/**
 * required bytes maintainerUUID = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getMaintaineruuid()`
 * @return {!Uint8Array}
 */
proto.filesync_daemon.PathNodeInfo.prototype.getMaintaineruuid_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getMaintaineruuid()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.filesync_daemon.PathNodeInfo} returns this
 */
proto.filesync_daemon.PathNodeInfo.prototype.setMaintaineruuid = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.PathNodeInfo} returns this
 */
proto.filesync_daemon.PathNodeInfo.prototype.clearMaintaineruuid = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.PathNodeInfo.prototype.hasMaintaineruuid = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * required bytes parentUUID = 3;
 * @return {!(string|Uint8Array)}
 */
proto.filesync_daemon.PathNodeInfo.prototype.getParentuuid = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * required bytes parentUUID = 3;
 * This is a type-conversion wrapper around `getParentuuid()`
 * @return {string}
 */
proto.filesync_daemon.PathNodeInfo.prototype.getParentuuid_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getParentuuid()));
};


/**
 * required bytes parentUUID = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getParentuuid()`
 * @return {!Uint8Array}
 */
proto.filesync_daemon.PathNodeInfo.prototype.getParentuuid_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getParentuuid()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.filesync_daemon.PathNodeInfo} returns this
 */
proto.filesync_daemon.PathNodeInfo.prototype.setParentuuid = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.PathNodeInfo} returns this
 */
proto.filesync_daemon.PathNodeInfo.prototype.clearParentuuid = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.PathNodeInfo.prototype.hasParentuuid = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * required bytes entryUUID = 4;
 * @return {!(string|Uint8Array)}
 */
proto.filesync_daemon.PathNodeInfo.prototype.getEntryuuid = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * required bytes entryUUID = 4;
 * This is a type-conversion wrapper around `getEntryuuid()`
 * @return {string}
 */
proto.filesync_daemon.PathNodeInfo.prototype.getEntryuuid_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getEntryuuid()));
};


/**
 * required bytes entryUUID = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getEntryuuid()`
 * @return {!Uint8Array}
 */
proto.filesync_daemon.PathNodeInfo.prototype.getEntryuuid_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getEntryuuid()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.filesync_daemon.PathNodeInfo} returns this
 */
proto.filesync_daemon.PathNodeInfo.prototype.setEntryuuid = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.PathNodeInfo} returns this
 */
proto.filesync_daemon.PathNodeInfo.prototype.clearEntryuuid = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.PathNodeInfo.prototype.hasEntryuuid = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * required string fsType = 5;
 * @return {string}
 */
proto.filesync_daemon.PathNodeInfo.prototype.getFstype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.filesync_daemon.PathNodeInfo} returns this
 */
proto.filesync_daemon.PathNodeInfo.prototype.setFstype = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.PathNodeInfo} returns this
 */
proto.filesync_daemon.PathNodeInfo.prototype.clearFstype = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.PathNodeInfo.prototype.hasFstype = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * required bytes version = 6;
 * @return {!(string|Uint8Array)}
 */
proto.filesync_daemon.PathNodeInfo.prototype.getVersion = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * required bytes version = 6;
 * This is a type-conversion wrapper around `getVersion()`
 * @return {string}
 */
proto.filesync_daemon.PathNodeInfo.prototype.getVersion_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getVersion()));
};


/**
 * required bytes version = 6;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getVersion()`
 * @return {!Uint8Array}
 */
proto.filesync_daemon.PathNodeInfo.prototype.getVersion_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getVersion()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.filesync_daemon.PathNodeInfo} returns this
 */
proto.filesync_daemon.PathNodeInfo.prototype.setVersion = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.PathNodeInfo} returns this
 */
proto.filesync_daemon.PathNodeInfo.prototype.clearVersion = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.PathNodeInfo.prototype.hasVersion = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * required string LastLocalFsUpdate = 7;
 * @return {string}
 */
proto.filesync_daemon.PathNodeInfo.prototype.getLastlocalfsupdate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.filesync_daemon.PathNodeInfo} returns this
 */
proto.filesync_daemon.PathNodeInfo.prototype.setLastlocalfsupdate = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.PathNodeInfo} returns this
 */
proto.filesync_daemon.PathNodeInfo.prototype.clearLastlocalfsupdate = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.PathNodeInfo.prototype.hasLastlocalfsupdate = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * required bytes linkedCollUUID = 8;
 * @return {!(string|Uint8Array)}
 */
proto.filesync_daemon.PathNodeInfo.prototype.getLinkedcolluuid = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * required bytes linkedCollUUID = 8;
 * This is a type-conversion wrapper around `getLinkedcolluuid()`
 * @return {string}
 */
proto.filesync_daemon.PathNodeInfo.prototype.getLinkedcolluuid_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getLinkedcolluuid()));
};


/**
 * required bytes linkedCollUUID = 8;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getLinkedcolluuid()`
 * @return {!Uint8Array}
 */
proto.filesync_daemon.PathNodeInfo.prototype.getLinkedcolluuid_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getLinkedcolluuid()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.filesync_daemon.PathNodeInfo} returns this
 */
proto.filesync_daemon.PathNodeInfo.prototype.setLinkedcolluuid = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.PathNodeInfo} returns this
 */
proto.filesync_daemon.PathNodeInfo.prototype.clearLinkedcolluuid = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.PathNodeInfo.prototype.hasLinkedcolluuid = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * required bytes linkedCollRootUUID = 9;
 * @return {!(string|Uint8Array)}
 */
proto.filesync_daemon.PathNodeInfo.prototype.getLinkedcollrootuuid = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * required bytes linkedCollRootUUID = 9;
 * This is a type-conversion wrapper around `getLinkedcollrootuuid()`
 * @return {string}
 */
proto.filesync_daemon.PathNodeInfo.prototype.getLinkedcollrootuuid_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getLinkedcollrootuuid()));
};


/**
 * required bytes linkedCollRootUUID = 9;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getLinkedcollrootuuid()`
 * @return {!Uint8Array}
 */
proto.filesync_daemon.PathNodeInfo.prototype.getLinkedcollrootuuid_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getLinkedcollrootuuid()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.filesync_daemon.PathNodeInfo} returns this
 */
proto.filesync_daemon.PathNodeInfo.prototype.setLinkedcollrootuuid = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.PathNodeInfo} returns this
 */
proto.filesync_daemon.PathNodeInfo.prototype.clearLinkedcollrootuuid = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.PathNodeInfo.prototype.hasLinkedcollrootuuid = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * required string name = 10;
 * @return {string}
 */
proto.filesync_daemon.PathNodeInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.filesync_daemon.PathNodeInfo} returns this
 */
proto.filesync_daemon.PathNodeInfo.prototype.setName = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.PathNodeInfo} returns this
 */
proto.filesync_daemon.PathNodeInfo.prototype.clearName = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.PathNodeInfo.prototype.hasName = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * required uint64 fileSize = 11;
 * @return {number}
 */
proto.filesync_daemon.PathNodeInfo.prototype.getFilesize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.filesync_daemon.PathNodeInfo} returns this
 */
proto.filesync_daemon.PathNodeInfo.prototype.setFilesize = function(value) {
  return jspb.Message.setField(this, 11, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.PathNodeInfo} returns this
 */
proto.filesync_daemon.PathNodeInfo.prototype.clearFilesize = function() {
  return jspb.Message.setField(this, 11, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.PathNodeInfo.prototype.hasFilesize = function() {
  return jspb.Message.getField(this, 11) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.filesync_daemon.CloudEvent.repeatedFields_ = [10,11];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.filesync_daemon.CloudEvent.prototype.toObject = function(opt_includeInstance) {
  return proto.filesync_daemon.CloudEvent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.filesync_daemon.CloudEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.filesync_daemon.CloudEvent.toObject = function(includeInstance, msg) {
  var f, obj = {
    eventtype: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    colluuid: msg.getColluuid_asB64(),
    parentuuid: msg.getParentuuid_asB64(),
    maintaineruuid: msg.getMaintaineruuid_asB64(),
    entryuuid: msg.getEntryuuid_asB64(),
    fstype: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f,
    version: msg.getVersion_asB64(),
    oldversion: msg.getOldversion_asB64(),
    filesize: (f = jspb.Message.getField(msg, 9)) == null ? undefined : f,
    newpathnodesList: (f = jspb.Message.getRepeatedField(msg, 10)) == null ? undefined : f,
    oldpathnodesList: (f = jspb.Message.getRepeatedField(msg, 11)) == null ? undefined : f,
    lastlocalfsupdate: (f = jspb.Message.getField(msg, 12)) == null ? undefined : f,
    linkedcolluuid: msg.getLinkedcolluuid_asB64(),
    linkedcollrootuuid: msg.getLinkedcollrootuuid_asB64(),
    userid: (f = jspb.Message.getField(msg, 15)) == null ? undefined : f,
    status: (f = jspb.Message.getField(msg, 16)) == null ? undefined : f,
    lockbyuserid: (f = jspb.Message.getField(msg, 17)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.filesync_daemon.CloudEvent}
 */
proto.filesync_daemon.CloudEvent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.filesync_daemon.CloudEvent;
  return proto.filesync_daemon.CloudEvent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.filesync_daemon.CloudEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.filesync_daemon.CloudEvent}
 */
proto.filesync_daemon.CloudEvent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.filesync_daemon.EventType} */ (reader.readEnum());
      msg.setEventtype(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setColluuid(value);
      break;
    case 3:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setParentuuid(value);
      break;
    case 4:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setMaintaineruuid(value);
      break;
    case 5:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setEntryuuid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setFstype(value);
      break;
    case 7:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setVersion(value);
      break;
    case 8:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setOldversion(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setFilesize(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.addNewpathnodes(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.addOldpathnodes(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastlocalfsupdate(value);
      break;
    case 13:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setLinkedcolluuid(value);
      break;
    case 14:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setLinkedcollrootuuid(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserid(value);
      break;
    case 16:
      var value = /** @type {!proto.filesync_daemon.CloudEvent.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setLockbyuserid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.filesync_daemon.CloudEvent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.filesync_daemon.CloudEvent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.filesync_daemon.CloudEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.filesync_daemon.CloudEvent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {!proto.filesync_daemon.EventType} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeBytes(
      2,
      f
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeBytes(
      3,
      f
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeBytes(
      4,
      f
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeBytes(
      5,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeBytes(
      7,
      f
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeBytes(
      8,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeUint64(
      9,
      f
    );
  }
  f = message.getNewpathnodesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      10,
      f
    );
  }
  f = message.getOldpathnodesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      11,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 12));
  if (f != null) {
    writer.writeString(
      12,
      f
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 13));
  if (f != null) {
    writer.writeBytes(
      13,
      f
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 14));
  if (f != null) {
    writer.writeBytes(
      14,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 15));
  if (f != null) {
    writer.writeString(
      15,
      f
    );
  }
  f = /** @type {!proto.filesync_daemon.CloudEvent.Status} */ (jspb.Message.getField(message, 16));
  if (f != null) {
    writer.writeEnum(
      16,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 17));
  if (f != null) {
    writer.writeString(
      17,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.filesync_daemon.CloudEvent.Status = {
  NOT_IN_DB: 0,
  QUEUED: 1,
  IN_PROGRESS: 2,
  COMPLETED: 3,
  FAILED: 4,
  HARD_FAILED: 5,
  ACCESS_DENIED: 6
};

/**
 * required EventType eventType = 1;
 * @return {!proto.filesync_daemon.EventType}
 */
proto.filesync_daemon.CloudEvent.prototype.getEventtype = function() {
  return /** @type {!proto.filesync_daemon.EventType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.filesync_daemon.EventType} value
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.setEventtype = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.clearEventtype = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.CloudEvent.prototype.hasEventtype = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * required bytes collUUID = 2;
 * @return {!(string|Uint8Array)}
 */
proto.filesync_daemon.CloudEvent.prototype.getColluuid = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * required bytes collUUID = 2;
 * This is a type-conversion wrapper around `getColluuid()`
 * @return {string}
 */
proto.filesync_daemon.CloudEvent.prototype.getColluuid_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getColluuid()));
};


/**
 * required bytes collUUID = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getColluuid()`
 * @return {!Uint8Array}
 */
proto.filesync_daemon.CloudEvent.prototype.getColluuid_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getColluuid()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.setColluuid = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.clearColluuid = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.CloudEvent.prototype.hasColluuid = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * required bytes parentUUID = 3;
 * @return {!(string|Uint8Array)}
 */
proto.filesync_daemon.CloudEvent.prototype.getParentuuid = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * required bytes parentUUID = 3;
 * This is a type-conversion wrapper around `getParentuuid()`
 * @return {string}
 */
proto.filesync_daemon.CloudEvent.prototype.getParentuuid_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getParentuuid()));
};


/**
 * required bytes parentUUID = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getParentuuid()`
 * @return {!Uint8Array}
 */
proto.filesync_daemon.CloudEvent.prototype.getParentuuid_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getParentuuid()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.setParentuuid = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.clearParentuuid = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.CloudEvent.prototype.hasParentuuid = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * required bytes maintainerUUID = 4;
 * @return {!(string|Uint8Array)}
 */
proto.filesync_daemon.CloudEvent.prototype.getMaintaineruuid = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * required bytes maintainerUUID = 4;
 * This is a type-conversion wrapper around `getMaintaineruuid()`
 * @return {string}
 */
proto.filesync_daemon.CloudEvent.prototype.getMaintaineruuid_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getMaintaineruuid()));
};


/**
 * required bytes maintainerUUID = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getMaintaineruuid()`
 * @return {!Uint8Array}
 */
proto.filesync_daemon.CloudEvent.prototype.getMaintaineruuid_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getMaintaineruuid()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.setMaintaineruuid = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.clearMaintaineruuid = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.CloudEvent.prototype.hasMaintaineruuid = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * required bytes entryUUID = 5;
 * @return {!(string|Uint8Array)}
 */
proto.filesync_daemon.CloudEvent.prototype.getEntryuuid = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * required bytes entryUUID = 5;
 * This is a type-conversion wrapper around `getEntryuuid()`
 * @return {string}
 */
proto.filesync_daemon.CloudEvent.prototype.getEntryuuid_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getEntryuuid()));
};


/**
 * required bytes entryUUID = 5;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getEntryuuid()`
 * @return {!Uint8Array}
 */
proto.filesync_daemon.CloudEvent.prototype.getEntryuuid_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getEntryuuid()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.setEntryuuid = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.clearEntryuuid = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.CloudEvent.prototype.hasEntryuuid = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * required string fsType = 6;
 * @return {string}
 */
proto.filesync_daemon.CloudEvent.prototype.getFstype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.setFstype = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.clearFstype = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.CloudEvent.prototype.hasFstype = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * required bytes version = 7;
 * @return {!(string|Uint8Array)}
 */
proto.filesync_daemon.CloudEvent.prototype.getVersion = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * required bytes version = 7;
 * This is a type-conversion wrapper around `getVersion()`
 * @return {string}
 */
proto.filesync_daemon.CloudEvent.prototype.getVersion_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getVersion()));
};


/**
 * required bytes version = 7;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getVersion()`
 * @return {!Uint8Array}
 */
proto.filesync_daemon.CloudEvent.prototype.getVersion_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getVersion()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.setVersion = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.clearVersion = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.CloudEvent.prototype.hasVersion = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * required bytes oldVersion = 8;
 * @return {!(string|Uint8Array)}
 */
proto.filesync_daemon.CloudEvent.prototype.getOldversion = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * required bytes oldVersion = 8;
 * This is a type-conversion wrapper around `getOldversion()`
 * @return {string}
 */
proto.filesync_daemon.CloudEvent.prototype.getOldversion_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getOldversion()));
};


/**
 * required bytes oldVersion = 8;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getOldversion()`
 * @return {!Uint8Array}
 */
proto.filesync_daemon.CloudEvent.prototype.getOldversion_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getOldversion()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.setOldversion = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.clearOldversion = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.CloudEvent.prototype.hasOldversion = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * required uint64 fileSize = 9;
 * @return {number}
 */
proto.filesync_daemon.CloudEvent.prototype.getFilesize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.setFilesize = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.clearFilesize = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.CloudEvent.prototype.hasFilesize = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * repeated string newPathNodes = 10;
 * @return {!Array<string>}
 */
proto.filesync_daemon.CloudEvent.prototype.getNewpathnodesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 10));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.setNewpathnodesList = function(value) {
  return jspb.Message.setField(this, 10, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.addNewpathnodes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 10, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.clearNewpathnodesList = function() {
  return this.setNewpathnodesList([]);
};


/**
 * repeated string oldPathNodes = 11;
 * @return {!Array<string>}
 */
proto.filesync_daemon.CloudEvent.prototype.getOldpathnodesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 11));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.setOldpathnodesList = function(value) {
  return jspb.Message.setField(this, 11, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.addOldpathnodes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 11, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.clearOldpathnodesList = function() {
  return this.setOldpathnodesList([]);
};


/**
 * required string LastLocalFsUpdate = 12;
 * @return {string}
 */
proto.filesync_daemon.CloudEvent.prototype.getLastlocalfsupdate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.setLastlocalfsupdate = function(value) {
  return jspb.Message.setField(this, 12, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.clearLastlocalfsupdate = function() {
  return jspb.Message.setField(this, 12, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.CloudEvent.prototype.hasLastlocalfsupdate = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * required bytes linkedCollUUID = 13;
 * @return {!(string|Uint8Array)}
 */
proto.filesync_daemon.CloudEvent.prototype.getLinkedcolluuid = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * required bytes linkedCollUUID = 13;
 * This is a type-conversion wrapper around `getLinkedcolluuid()`
 * @return {string}
 */
proto.filesync_daemon.CloudEvent.prototype.getLinkedcolluuid_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getLinkedcolluuid()));
};


/**
 * required bytes linkedCollUUID = 13;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getLinkedcolluuid()`
 * @return {!Uint8Array}
 */
proto.filesync_daemon.CloudEvent.prototype.getLinkedcolluuid_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getLinkedcolluuid()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.setLinkedcolluuid = function(value) {
  return jspb.Message.setField(this, 13, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.clearLinkedcolluuid = function() {
  return jspb.Message.setField(this, 13, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.CloudEvent.prototype.hasLinkedcolluuid = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * required bytes linkedCollRootUUID = 14;
 * @return {!(string|Uint8Array)}
 */
proto.filesync_daemon.CloudEvent.prototype.getLinkedcollrootuuid = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * required bytes linkedCollRootUUID = 14;
 * This is a type-conversion wrapper around `getLinkedcollrootuuid()`
 * @return {string}
 */
proto.filesync_daemon.CloudEvent.prototype.getLinkedcollrootuuid_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getLinkedcollrootuuid()));
};


/**
 * required bytes linkedCollRootUUID = 14;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getLinkedcollrootuuid()`
 * @return {!Uint8Array}
 */
proto.filesync_daemon.CloudEvent.prototype.getLinkedcollrootuuid_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getLinkedcollrootuuid()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.setLinkedcollrootuuid = function(value) {
  return jspb.Message.setField(this, 14, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.clearLinkedcollrootuuid = function() {
  return jspb.Message.setField(this, 14, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.CloudEvent.prototype.hasLinkedcollrootuuid = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * required string userID = 15;
 * @return {string}
 */
proto.filesync_daemon.CloudEvent.prototype.getUserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.setUserid = function(value) {
  return jspb.Message.setField(this, 15, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.clearUserid = function() {
  return jspb.Message.setField(this, 15, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.CloudEvent.prototype.hasUserid = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * required Status status = 16;
 * @return {!proto.filesync_daemon.CloudEvent.Status}
 */
proto.filesync_daemon.CloudEvent.prototype.getStatus = function() {
  return /** @type {!proto.filesync_daemon.CloudEvent.Status} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {!proto.filesync_daemon.CloudEvent.Status} value
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.setStatus = function(value) {
  return jspb.Message.setField(this, 16, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.clearStatus = function() {
  return jspb.Message.setField(this, 16, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.CloudEvent.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * required string lockByUserID = 17;
 * @return {string}
 */
proto.filesync_daemon.CloudEvent.prototype.getLockbyuserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.setLockbyuserid = function(value) {
  return jspb.Message.setField(this, 17, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.CloudEvent} returns this
 */
proto.filesync_daemon.CloudEvent.prototype.clearLockbyuserid = function() {
  return jspb.Message.setField(this, 17, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.CloudEvent.prototype.hasLockbyuserid = function() {
  return jspb.Message.getField(this, 17) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.filesync_daemon.AsyncJob.prototype.toObject = function(opt_includeInstance) {
  return proto.filesync_daemon.AsyncJob.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.filesync_daemon.AsyncJob} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.filesync_daemon.AsyncJob.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestid: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    userid: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
    jobType: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
    status: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
    errorMessage: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
    percentage: (f = jspb.Message.getOptionalFloatingPointField(msg, 6)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.filesync_daemon.AsyncJob}
 */
proto.filesync_daemon.AsyncJob.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.filesync_daemon.AsyncJob;
  return proto.filesync_daemon.AsyncJob.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.filesync_daemon.AsyncJob} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.filesync_daemon.AsyncJob}
 */
proto.filesync_daemon.AsyncJob.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserid(value);
      break;
    case 3:
      var value = /** @type {!proto.filesync_daemon.AsyncJob.Type} */ (reader.readEnum());
      msg.setJobType(value);
      break;
    case 4:
      var value = /** @type {!proto.filesync_daemon.AsyncJob.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrorMessage(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setPercentage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.filesync_daemon.AsyncJob.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.filesync_daemon.AsyncJob.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.filesync_daemon.AsyncJob} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.filesync_daemon.AsyncJob.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {!proto.filesync_daemon.AsyncJob.Type} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = /** @type {!proto.filesync_daemon.AsyncJob.Status} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeFloat(
      6,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.filesync_daemon.AsyncJob.Type = {
  UNKNOWN: 0,
  SYNC: 1,
  SHARE: 2,
  EDIT: 3,
  SYNC_V2: 4,
  COLLECTION_RENAME: 5,
  CLOUD_FILE: 6
};

/**
 * @enum {number}
 */
proto.filesync_daemon.AsyncJob.Status = {
  NOT_IN_DB: 0,
  QUEUED: 1,
  IN_PROGRESS: 2,
  COMPLETED: 3,
  FAILED: 4,
  HARD_FAILED: 5,
  ACCESS_DENIED: 6
};

/**
 * required string requestId = 1;
 * @return {string}
 */
proto.filesync_daemon.AsyncJob.prototype.getRequestid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.filesync_daemon.AsyncJob} returns this
 */
proto.filesync_daemon.AsyncJob.prototype.setRequestid = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.AsyncJob} returns this
 */
proto.filesync_daemon.AsyncJob.prototype.clearRequestid = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.AsyncJob.prototype.hasRequestid = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * required string userId = 2;
 * @return {string}
 */
proto.filesync_daemon.AsyncJob.prototype.getUserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.filesync_daemon.AsyncJob} returns this
 */
proto.filesync_daemon.AsyncJob.prototype.setUserid = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.AsyncJob} returns this
 */
proto.filesync_daemon.AsyncJob.prototype.clearUserid = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.AsyncJob.prototype.hasUserid = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * required Type job_type = 3;
 * @return {!proto.filesync_daemon.AsyncJob.Type}
 */
proto.filesync_daemon.AsyncJob.prototype.getJobType = function() {
  return /** @type {!proto.filesync_daemon.AsyncJob.Type} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.filesync_daemon.AsyncJob.Type} value
 * @return {!proto.filesync_daemon.AsyncJob} returns this
 */
proto.filesync_daemon.AsyncJob.prototype.setJobType = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.AsyncJob} returns this
 */
proto.filesync_daemon.AsyncJob.prototype.clearJobType = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.AsyncJob.prototype.hasJobType = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * required Status status = 4;
 * @return {!proto.filesync_daemon.AsyncJob.Status}
 */
proto.filesync_daemon.AsyncJob.prototype.getStatus = function() {
  return /** @type {!proto.filesync_daemon.AsyncJob.Status} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.filesync_daemon.AsyncJob.Status} value
 * @return {!proto.filesync_daemon.AsyncJob} returns this
 */
proto.filesync_daemon.AsyncJob.prototype.setStatus = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.AsyncJob} returns this
 */
proto.filesync_daemon.AsyncJob.prototype.clearStatus = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.AsyncJob.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string error_message = 5;
 * @return {string}
 */
proto.filesync_daemon.AsyncJob.prototype.getErrorMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.filesync_daemon.AsyncJob} returns this
 */
proto.filesync_daemon.AsyncJob.prototype.setErrorMessage = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.AsyncJob} returns this
 */
proto.filesync_daemon.AsyncJob.prototype.clearErrorMessage = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.AsyncJob.prototype.hasErrorMessage = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional float percentage = 6;
 * @return {number}
 */
proto.filesync_daemon.AsyncJob.prototype.getPercentage = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.filesync_daemon.AsyncJob} returns this
 */
proto.filesync_daemon.AsyncJob.prototype.setPercentage = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.filesync_daemon.AsyncJob} returns this
 */
proto.filesync_daemon.AsyncJob.prototype.clearPercentage = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filesync_daemon.AsyncJob.prototype.hasPercentage = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * @enum {number}
 */
proto.filesync_daemon.EventType = {
  UNKNOWN: 0,
  CREATE: 1,
  UPDATE_FILE: 2,
  UPDATE_RENAME: 3,
  UPDATE_MOVE: 4,
  DELETE: 5,
  UPDATE_SHARE: 6,
  LOCK_FILE: 7,
  UNLOCK_FILE: 8
};

goog.object.extend(exports, proto.filesync_daemon);
